export const getCurrentPlanMatchLimit = (plan?: object, totalRequests?: number): number => {
  if (totalRequests !== undefined) return totalRequests;
  if (!plan) return 5;
  // @ts-ignore
  return plan.num_requests || 500;
};
